var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFxSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx-selected_svg__filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fx-selected_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fx-selected_svg__\\u97F3\\u9891\\u7F16\\u8F91",
    transform: "translate(-30.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fx-selected_svg__\\u7F16\\u7EC4-2",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fx-selected_svg__FX",
    transform: "translate(30.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fx-selected_svg__\\u77E9\\u5F62",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#4A43AA",
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fx-selected_svg__filter-1)",
    id: "fx-selected_svg__\\u7F16\\u7EC4-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fx-selected_svg__\\u77E9\\u5F62",
    fill: "#583B94",
    x: 0,
    y: 0,
    width: 34,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "fx-selected_svg__\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#583B94",
    x: 0,
    y: 23,
    width: 34,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,19 L0,19 L0,5 L14,5 L14,9 L9,9 L9,11 L14,11 L14,15 L9,15 L9,19 Z",
    id: "fx-selected_svg__path-fx-selected",
    fill: "#583B94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "fx-selected_svg__\\u8DEF\\u5F84",
    fill: "#583B94",
    fillRule: "nonzero",
    points: "34 19 25.9402985 5 16 5 16 5.15979708 23.8773987 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "fx-selected_svg__\\u8DEF\\u5F84",
    fill: "#583B94",
    fillRule: "nonzero",
    points: "30.9449929 10 34 5 28 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "fx-selected_svg__\\u8DEF\\u5F84",
    fill: "#583B94",
    fillRule: "nonzero",
    points: "22 19 19.0710059 14 16 19"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxSelected);
export default __webpack_public_path__ + "static/media/fx-selected.e5d35689.svg";
export { ForwardRef as ReactComponent };